export enum RoutingUrls {
  Accounts = 'accounts',
  Quotes = 'quotes',
  Prototypes = 'prototypes',
  Dashboard = 'dashboard',
  Catalog = 'catalog',
  CompareProducts = 'compare-products',
  Search = 'search',
  Viewer = 'viewer',
  Profile = 'profile',
  Maintenance = 'maintenance',
  MasterTemplates = 'masterTemplates',
  BomTemplates = 'bomTemplates',
  Forbidden = '403',
  NotFound = '404',
}

export enum RoutesMode {
  newRoute = 'newRoute',
  viewRoute = 'viewRoute',
  respondToRoute = 'respondToRoute',
  transferOwnership = 'transferOwnership',
}
